// extracted by mini-css-extract-plugin
export default {"logoSize":"ComingSoon_logoSize__oS55u","infoSize":"ComingSoon_infoSize__z5a5V"};